import { useEffect, useState } from "react"
import { PaginationType, PositionType } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { getPosition } from "@/lib/api/billing"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { positionColumns } from "@/components/table/columns/position-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import AddPositionPage from "./add"

export const Route = createFileRoute("/_home/user-role-management/position/")({
  component: PositionPage,
})

function PositionPage() {
  const [showExportModal, setShowExportModal] = useState<boolean>(false)
  const [defaultPage, setDefaultPage] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [search, setSearch] = useState<string>("")

  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [prevPageUrl, setPrevPageUrl] = useState<string | null>(null)

  const {
    data: positionDetails,
    isError,
    isLoading,
  } = useQuery<PaginationType<PositionType>>({
    queryKey: ["positionDetails", defaultPage, page, search],
    queryFn: () => getPosition(defaultPage, page, search),
  })

  useEffect(() => {
    if (positionDetails) {
      setNextPageUrl(positionDetails.next)
      setPrevPageUrl(positionDetails.previous)
    }
  }, [positionDetails])

  return (
    <div className="space-y-4 p-4">
      <Header>Position</Header>
      <DataTable
        columns={positionColumns}
        data={positionDetails?.results ?? []}
        search={{
          label: "Departments",
          value: search,
          onChange: setSearch,
        }}
        isLoading={isLoading}
        isError={isError}
        defaultPage={defaultPage}
        setDefaultPage={setDefaultPage}
        nextPageUrl={nextPageUrl}
        prevPageUrl={prevPageUrl}
        page={page}
        setPage={setPage}
        totalCount={positionDetails?.count}
      >
        <div className="flex w-full justify-end gap-1">
          <AddPositionPage />
          <ExportOperationModal
            tableData={positionDetails?.results ?? [{}]}
            fileName="Position"
            showExportModal={showExportModal}
            setShowExportModal={setShowExportModal}
          />
        </div>
      </DataTable>
    </div>
  )
}
